import React, { useEffect, useState, useRef } from 'react';
import './About.css';

const About = React.forwardRef((props, ref) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={(el) => { sectionRef.current = el; if (ref) ref.current = el; }} className="about">
      <div className="container">
        <div className={`about-content ${isVisible ? 'visible' : ''}`}>
          <div className="about-text">
            <h2 className="section-title">Sobre Mim</h2>
            <p className="about-description">
              Olá! Sou Rikelmy Cavalcante, tenho 18 anos e sou de Arapiraca, Alagoas. 
              Atualmente estou cursando Cibersegurança na UniFatecie, mas minha paixão 
              vai além da segurança digital.
            </p>
            <p className="about-description">
              Sou desenvolvedor full stack com experiência em React, React Native, 
              JavaScript, HTML e CSS. Adoro criar aplicações que resolvem problemas 
              reais e proporcionam experiências incríveis aos usuários.
            </p>
            <p className="about-description">
              Além do desenvolvimento, também trabalho com Motion Design e edição de 
              fotos, combinando código e criatividade para entregar projetos únicos.
            </p>

            <div className="about-info">
              <div className="info-item">
                <span className="info-icon">📍</span>
                <div>
                  <div className="info-label">Localização</div>
                  <div className="info-value">Arapiraca, AL, Brasil</div>
                </div>
              </div>
              <div className="info-item">
                <span className="info-icon">🎓</span>
                <div>
                  <div className="info-label">Educação</div>
                  <div className="info-value">Cibersegurança - UniFatecie</div>
                </div>
              </div>
              <div className="info-item">
                <span className="info-icon">🌐</span>
                <div>
                  <div className="info-label">Idiomas</div>
                  <div className="info-value">Português, Inglês (B2)</div>
                </div>
              </div>
            </div>
          </div>

          <div className="about-visual">
            <div className="visual-card card-1">
              <div className="card-icon">💻</div>
              <h3>Desenvolvimento</h3>
              <p>Apps mobile e web com React e React Native</p>
            </div>
            <div className="visual-card card-2">
              <div className="card-icon">🎨</div>
              <h3>Design</h3>
              <p>Motion design e edição criativa</p>
            </div>
            <div className="visual-card card-3">
              <div className="card-icon">🔒</div>
              <h3>Segurança</h3>
              <p>Estudante de Cibersegurança</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
});

export default About;
